<script setup>
const props = defineProps({
  initialActiveTab: {
    type: Number,
    default: 0,
  },
  tabs: {
    type: Array,
    required: true,
    validator: value => {
      return value.every(
        tab =>
          typeof tab.label === 'string' &&
          (tab.count ? typeof tab.count === 'number' : true)
      );
    },
  },
});

const emit = defineEmits(['tabChanged']);

const selectTab = index => {
  emit('tabChanged', props.tabs[index]);
};
</script>

<template>
  <div
    class="flex w-full min-w-0 flex-wrap items-end gap-x-0 gap-y-1"
    role="tablist"
  >
    <button
      v-for="(tab, index) in tabs"
      :key="index"
      type="button"
      role="tab"
      :aria-selected="props.initialActiveTab === index"
      class="relative overflow-visible rounded-md border-0 bg-transparent px-3 pb-2 pt-1 text-start text-base font-bold text-black outline-none transition-colors duration-200 ease-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-n-blue-9 dark:text-n-slate-12"
      :class="[
        props.initialActiveTab === index
          ? 'hover:text-black dark:hover:text-n-slate-12'
          : 'hover:bg-n-alpha-2 hover:text-black dark:hover:text-n-slate-12',
      ]"
      @click="selectTab(index)"
    >
      <span class="relative inline-block max-w-full whitespace-nowrap">
        {{ tab.label }}{{ tab.count != null ? ` (${tab.count})` : '' }}
        <span
          v-if="props.initialActiveTab === index"
          class="pointer-events-none absolute start-0 end-0 top-full mt-0.5 h-1.5 rounded-full bg-n-blue-9"
          aria-hidden="true"
        />
      </span>
    </button>
  </div>
</template>
